<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="contractFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#contractFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('online_contract.title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="title"
                                                dir="rtl"
                                                name="title"
                                                id="title"
                                                v-model="query.title"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('label.status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                size="3"
                                                id="status"
                                                class="form-control"
                                                name="status"
                                                v-model="query.status"
                                            >
                                                <option value="">
                                                    {{ $t('selectpicker.nothing_selected') }}
                                                </option>
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in contractStatus"
                                                    v-bind:value="status"
                                                    :selected="query.status === status"
                                                >
                                                    {{ contractStatusStr.get(status) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('label.online_contract.id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="contract_id"
                                                dir="ltr"
                                                name="contract_id"
                                                id="contract_id"
                                                v-model="query.contract_id"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="user_full_name">
                                                {{ $t('online_contract.user_full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="user_full_name"
                                                dir="rtl"
                                                name="user_full_name"
                                                id="user_full_name"
                                                v-model="query.user_full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD 00:00:00"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="from_date"
                                                name="from_date"
                                                v-model="query.from_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD 23:59:59"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="to_date"
                                                name="to_date"
                                                v-model="query.to_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="start_at">
                                                {{ $t('label.online_contract.start_date') }}
                                            </kt-form-label>
                                            <button id="start_at"
                                                    @click="clearStartDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="start_at"
                                                name="start_at"
                                                v-model="query.start_at"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="end_at">
                                                {{ $t('label.online_contract.end_date') }}
                                            </kt-form-label>
                                            <button id="end_at"
                                                    @click="clearEndDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="end_at"
                                                name="end_at"
                                                v-model="query.end_at"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="2" style="margin-top: 26px">
                                        <kt-form-section>
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-form-section>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {contractStatus, contractStatusStr} from '@/constants/onlineContract'
import $ from "jquery";
import {i18n} from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
        clearStartDate() {
            if(this.query.start_at) {
                this.query.start_at = null
            }
        },
        clearEndDate() {
            if(this.query.end_at) {
                this.query.end_at = null
            }
        },
    },
    data() {
        return {
            contractStatus,
            contractStatusStr,
            query: {
                status: null
            },
        }
    }
}
</script>

<style>

</style>